import { createSelector } from 'reselect';
import {
    clientSelector,
    shiftIdSelector,
    selectedDateSelector,
    activeTeamIdsSelector,
    userIdSelector
} from './queryParamsSelectors';
import Immutable from 'immutable';

const eventGroupToMap = eventData => {
    const eventsCount = eventData.get('eventsCount') ?? 0;
    const eventGroups = eventData.get('eventGroups') ?? Immutable.List();
    const eventGroupToIdMap = eventGroups.reduce((all, curr) => {
        all[curr.get('definitionId')] = curr;
        return all;
    }, {});
    return Immutable.fromJS({
        eventGroupToIdMap,
        eventsCount
    });
};

export const getTeamIds = (state, props) => {
    var teamIds = activeTeamIdsSelector(state, props);
    return teamIds && teamIds.length > 0 ? teamIds.join(',') : undefined;
};

export const eventGroupSelector = createSelector(
    [
        clientSelector,
        shiftIdSelector,
        selectedDateSelector,
        getTeamIds,
        userIdSelector,
        state => state.eventGroup,
        (state, props, options) => options
    ],
    (clientId, shiftId, date, teamIds, userId, eventGroup, options) => {
        if (options && options.date) {
            return eventGroup.getIn(
                ['records', clientId, options.date, teamIds, userId, 'entity'],
                Immutable.List()
            );
        }
        return eventGroup.getIn(
            ['records', clientId, date, teamIds, userId, 'entity'],
            Immutable.List()
        );
    }
);

export const eventGroupMapSelector = createSelector(
    [eventGroupSelector],
    eventGroupToMap
);

export const userEventGroupSelector = createSelector(
    [
        clientSelector,
        shiftIdSelector,
        selectedDateSelector,
        userIdSelector,
        state => state.eventGroup
    ],
    (clientId, shiftId, date, userId, eventGroup) => {
        return eventGroup.getIn(
            ['records', clientId, date, undefined, userId, 'entity'],
            Immutable.List()
        );
    }
);

export const getEventGroupFetchStatus = createSelector(
    [
        clientSelector,
        shiftIdSelector,
        selectedDateSelector,
        getTeamIds,
        userIdSelector,
        state => state.eventGroup,
        (state, props, options) => options
    ],
    (clientId, shiftId, date, teamIds, userId, eventGroup, options) => {
        return eventGroup.getIn(
            [
                'records',
                clientId,
                options && options.date ? options.date : date,
                teamIds,
                userId,
                'status',
                'isLoading'
            ],
            true
        );
    }
);

export const getUserEventGroupFetchStatus = createSelector(
    [
        clientSelector,
        selectedDateSelector,
        userIdSelector,
        state => state.eventGroup,
        (state, props, options) => options
    ],
    (clientId, date, userId, eventGroup, options) => {
        return eventGroup.getIn(
            [
                'records',
                clientId,
                options && options.date ? options.date : date,
                undefined,
                userId,
                'status',
                'isLoading'
            ],
            true
        );
    }
);

export const userEventGroupMapSelector = createSelector(
    [userEventGroupSelector],
    eventGroupToMap
);
